export default {
  sections: {
    order_summary: 'Gesamtbestellung',
  },
  labels: {
    add_items: 'Artikel hinzufügen, um loszulegen',
    item_count_one: '{{count}} Artikel',
    item_count_other: '{{count}} Artikel',
  },
  buttons: {
    return: 'Zurück zur Bestellübersicht',
  },
};
